const ButtonLabels = {
    saveLabel: "Save",
    updateLabel: "Update",

    activeLabel: "Mark as active",
    leaveLabel: "Mark as leave"
}

export default ButtonLabels;